import axios from 'axios'
import { getCookie } from '@/util'
import router from '@/router'

const headers = { 'X-Requested-With': 'XMLHttpRequest' }

// 요청 인터셉터 추가
axios.interceptors.request.use(
  function (config) {
    // 요청을 보내기 전에 수행할 일
    if (config.isLoading) {
      window.getApp.$emit('LOADING_START')
    }

    if (router.currentRoute.meta.menu) {
      config.headers.Menu = router.currentRoute.meta.menu
    }

    const testuser = getCookie('testuser')
    if (testuser != null && testuser !== 'null') {
      config.headers.testuser = testuser
    }

    if (config.isMultipart) {
      config.headers['Content-Type'] = 'multipart/form-data'
    }

    return config
  },
  function (error) {
    // 오류 요청을 보내기전 수행할 일
    return Promise.reject(error)
  })

// 응답 인터셉터 추가
axios.interceptors.response.use(
  function (response) {
    if (window.getApp) {
      window.getApp.$emit('LOADING_END')
    }

    // 응답 데이터를 가공
    // response.data.detail !== 'success'
    if (response.status !== 200) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        exception: {
          detail: response.data.detail,
          message: response.data.data
        }
      })
    }
    return response
  },
  function (error) {
    // 오류 응답을 처리
    if (window.getApp) {
      window.getApp.$emit('LOADING_END')
    }
    // TODO: error page로 이동?
    // router.replace({
    //   name: 'Error'
    // })
    return Promise.reject(error)
  })

const getPromise = (method, uri, data = null, options) => {
  const config = {
    method: method,
    url: uri,
    headers: headers,
    ...options
  }

  if (method.toUpperCase() === 'GET') {
    config.params = data
  } else {
    config.data = data
  }

  return axios(config)
  .then(response => {
    return Promise.resolve(response.data)
  })
  .catch(error => {
    return Promise.reject(error)
  })
}

const call = (method, uri, data = null, callback, errorHandler, options) => {
  axios({
    method: method,
    url: uri,
    data: data,
    headers: headers
  })
  .then(res => {
    callback(res)
  })
  .catch(error => {
    console.log('error: ' + error)
  })
  .then(() => {
    // always executed
    console.log('executed')
  })
}

export default {
  call,
  getPromise
}
